<template>
  <div class="w-full">
      <div class="text-center text-3xl py-6">{{ _("You're too far to grab this call.")}}</div>
      
      <div class="text-center">{{ _( "Get Closer" ) }}</div>
  </div>
</template>

<script>
import PhoneFormatter from "../Shared/PhoneFormatter";
import {lang} from "../lang";
import IconClockOutline from "../../icons/outline/IconClockOutline";
export default {
  name: "TooFar",
    components: {IconClockOutline, PhoneFormatter},
    props: [
        'app_locale'
    ],
    data() {
        return {
            grabbing: false,
        }
    },
    
    methods: {
      
      
        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
        },
    }
}
</script>

<style scoped>

</style>
